import React from 'react';
import styled from 'styled-components';
import { CaseStatus } from '../../../services/buildfire/rdb/cases';
import ExpandingButton from '../../common/ExpandingButton';
import { useLinkButtonProps } from '../../common/LinkButton';
import CaseInfo, { CaseInfoProps } from './CaseInfo';
import CaseInfoHeader from '../CaseInfoHeader';
import { generatePath, useRouteMatch } from 'react-router-dom';
import { isOpen } from '../../../util/case';
import CustomerReport from '../report/CustomerReport';

interface CustomerCaseInfoProps extends CaseInfoProps {}

const ReportContainer = styled.div`
  padding: 0 32px;
  text-align: center;
`;

const Banner = styled.div`
  padding: 4px;
  background: var(--ion-color-secondary);
  color: white;
`;

const CustomerCaseInfo: React.FC<CustomerCaseInfoProps> = ({
  case: c,
  ...props
}) => {
  const linkButtonProps = useLinkButtonProps();
  const isBillingParentAccount =
    c.invoiceAccount && c.invoiceAccount.uid !== c.uid;
  const invoiceBanner = isBillingParentAccount ? (
    <Banner>Case billed to {c.invoiceAccount?.displayName}</Banner>
  ) : null;
  const match = useRouteMatch();
  const reportPath = generatePath(`${match.path}/report`, {
    caseId: c.id,
    userId: c.uid,
  });
  const caseInfoRouteMatch = useRouteMatch('/cases/:caseId');
  const isOnCaseInfoPage = caseInfoRouteMatch?.isExact || false;

  if (!isOpen(c)) {
    return <CustomerReport />;
  }

  return (
    <>
      <CaseInfoHeader
        case={c}
        actionItems={isOnCaseInfoPage ? props.actionItems : null}
        isAdmin={false}
      />

      <CaseInfo case={c} bannerContent={invoiceBanner} {...props}>
        {c.status === CaseStatus.SIGNED_OFF && (
          <ReportContainer>
            <ExpandingButton
              variant="primary"
              size="large"
              role={linkButtonProps.role}
              onClick={linkButtonProps.onClick(reportPath)}
            >
              View report
            </ExpandingButton>
          </ReportContainer>
        )}
      </CaseInfo>
    </>
  );
};

export default CustomerCaseInfo;
